import React from 'react';
import Input from '../elements/Input';

const DigitalPresenceForm = ({ formData, setFormData, formError }) => (
  <>
    <Input
      label="Account Type"
      value={formData.accountType || ''}
      onChange={e => setFormData({ ...formData, accountType: e.target.value })}
      placeholder="e.g. Gmail, Facebook, Netflix, Twitter"
      error={formError.accountType}
    />
    <Input
      label="Username / Email"
      value={formData.username || ''}
      onChange={e => setFormData({ ...formData, username: e.target.value })}
      placeholder="e.g. jane.doe@gmail.com, johndoe_92"
      error={formError.username}
    />
    <Input
      label="Password"
      value={formData.password || ''}
      onChange={e => setFormData({ ...formData, password: e.target.value })}
      placeholder="e.g. My$ecureP@ssw0rd!"
      error={formError.password || "Save password hints instead of actual passwords for security"}
    />
    <Input
      label="Notes / Details"
      type="textarea"
      value={formData.notes || ''}
      onChange={e => setFormData({ ...formData, notes: e.target.value })}
      placeholder="e.g. Recovery email: altmail@gmail.com, 2FA enabled, backup codes saved"
      error={formError.notes}
    />
  </>
);

export default DigitalPresenceForm;